import type { Question } from "../../types/onboarding";

export const allQuestions: Question[] = [
	{
		id: "setupProfile",
		type: "setup-profile",
		title: "Set Up Your Profile",
		question: "Initial details to start your journey with EraBorn",
		field: "setupProfile",
		fields: ["userType", "firstName", "lastName", "countryCity"],
		options: [
			{
				value: "b2c",
				label: "Intended parent",
				description: "Intended parent",
				icon: "/images/intended-parents-image.png",
				badge: "/images/pink-heart-badge.png",
			},
			{
				value: "partner",
				label: "Supporting someone",
				description: "Supporting someone on their journey",
				icon: "/images/supporting-someone-image.png",
				badge: "/images/support-badge.png",
			},
		],
	},
	{
		id: "setupProfileDetails",
		type: "setup-profile-details",
		title: "Set Up Your Profile",
		question: "Initial details to start your journey with EraBorn",
		field: "setupProfileDetails",
		fields: ["yearOfBirth", "gender"],
		options: [],
	},
	{
		id: "fertilityStatus",
		type: "fertility-status",
		title: "To personalize your journey, please share your current status",
		question: "",
		field: "fertilityStatus",
		options: [],
	},
	{
		id: "fertilityRole",
		type: "fertility-role",
		title: "Please select your role in the fertility journey",
		question: "",
		field: "fertilityRole",
		options: [],
	},
	{
		id: "fertilityJourneyTypes",
		type: "fertility-journey-types",
		title: "The journey currently includes",
		question: "",
		field: "fertilityJourneyTypes",
		options: [],
	},
	{
		id: "needsMost",
		type: "needs-most",
		title: "What do you need most right now?",
		question: "",
		field: "needsMost",
		options: [],
	},
	{
		id: "howDidYouHear",
		type: "how-did-you-hear",
		title: "How did you hear about EraBorn?",
		question: "",
		field: "howDidYouHearAboutUs",
		options: [],
	},
	{
		id: "additionalInfo",
		type: "additional-info",
		title: "Preparing your personalized experience",
		question: "Are there any additional conditions we need to know about?",
		field: "additionalInformation",
		options: [],
	},
];
